module.exports = __webpack_public_path__ + "media/images/home-page/2-6738ecd010353ef73c7c27e7be6d45c7.png";